import { Button } from "@aidron/aidron-ds";
import { useState, useMemo, memo, useCallback } from "react";
import { ModalTemplate } from "../sharedComponents.index";

export const ButtonWithModal = memo(function ButtonWithModal({ ctx, uiState }) {
  const { 
    label, 
    iconPosition = "right", 
    icon = "arrow-up-right", 
    type = "outlined", 
    size = "", 
    modalHeading = " ",
    modalWidth = "900px", 
    renderModalContent = () => {}, 
    className = "",
    onOpen = null
  } = ctx || {};

  const { disabled = false, page = 'default' } = uiState || {};

  const [showModal, setShowModal] = useState(false);

  const onOpenModal = useCallback(() => {
    if (typeof onOpen === 'function') onOpen();
    setShowModal(true);
  }, [onOpen]);
  
  const onCloseModal = useCallback(() => setShowModal(false), []);

  return (
    <>
      <Button
        label={label}
        onClick={onOpenModal}
        icon={icon}
        position={iconPosition}
        type={type}
        size={size}
        disabled={disabled}
        className={className}
      />
      <ModalTemplate
        open={showModal}
        width={modalWidth}
        heading={modalHeading}
        closingFunction={onCloseModal}
      >
        {showModal && renderModalContent({ closeModal: onCloseModal })}
      </ModalTemplate>
    </>
  );
});